import fp from 'lodash/fp'
import { ERROR_MESSAGES } from 'egoist-js'

import {
  MATCH_PROP_KEY,
  NOT_MATCH_SELECTED_TEAM_KEY,
  AMOUNT_MORE_THAN_MAXIMUM,
  AMOUNT_MORE_THAN_MAXIMUM_BET,
  AMOUNT_MORE_THAN_MIN_BET,
} from './custom-validators'

export const customMessages = {
  [MATCH_PROP_KEY]: ({ label, args }) =>
    `Passwords do not match`,
  [NOT_MATCH_SELECTED_TEAM_KEY]: () =>
    'Same team should not be selected as home and away team',
  [AMOUNT_MORE_THAN_MAXIMUM]: () => 'the amount is more than the maximum',
  [AMOUNT_MORE_THAN_MAXIMUM_BET]: () => 'the amount is more than the 200',
  [AMOUNT_MORE_THAN_MIN_BET]: () => 'the amount must be greater than 0',
  ...ERROR_MESSAGES,
}
